import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { useNavigate } from "react-router-dom";
import { GetClicksProps, GetReportsProps } from "declarations/reportServices";
import { fetchCommonPageProps } from "declarations/common";
import { GetClicks, GetReports } from "api/services/report";
import { setProgressBarActive } from "reducers/pageReducer";
import { setClicks, setReports } from "reducers/reportReducer";
import { useAsyncOperation } from "./useAsyncOperation";

export default function useReport() {
  const { execute } = useAsyncOperation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { reports, clicks } = useSelector((state: RootState) => state.report);

  const getReports = async (
    { limit, offset, setLoading }: GetReportsProps,
    { local, more, reload }: fetchCommonPageProps
  ) => {
    if (reports && reports.length > 0 && !local && !more && !reload) return;
    
    try {
      const response = await execute(
        () => GetReports({ setLoading, offset, limit }),
        { errorMessage: "Fetching Reports Failed" }
      );
      const { reports: loadedReports, message, status } = response;
      
      if (status !== 200) throw new Error(message);
      
      let totalReports = [...loadedReports];
      
      if (local) return totalReports;
      if (more) totalReports = [...reports, ...loadedReports];

      dispatch(setReports(totalReports));
    } catch (error) {}
  };

  const getClicks = async (
    { limit, offset, setLoading }: GetClicksProps,
    { local, more, reload }: fetchCommonPageProps
  ) => {
    if (clicks && clicks.length > 0 && !local && !more && !reload) return;
    
    try {
      const response = await execute(
        () => GetClicks({ setLoading, offset, limit }),
        { errorMessage: "Fetching Clicks Failed" }
      );
    
      const { clicks: loadedClicks, message, status } = response;
    
      if (status !== 200) throw new Error(message);
    
      let totalClicks = [...loadedClicks];
    
      if (local) return totalClicks;
      if (more) totalClicks = [...clicks, ...loadedClicks];

      dispatch(setClicks(totalClicks));
    } catch (error) {}
  };

  return {
    getReports,
    getClicks,
  };
}
